import React from 'react';
import { Outlet } from 'react-router-dom';
import { DeviceSelector as DeviceSelectorNew } from '@/components/shared/DeviceSelectorNew';
import { AnalyticsProvider, useAnalytics } from './AnalyticsContext';
import { FiDatabase } from 'react-icons/fi';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

// Inner component that uses the context
const AnalyticsLayoutInner: React.FC = () => {
  const { deviceId, setDeviceId } = useAnalytics();
  const { mode } = useSelector((state: RootState) => state.theme);

  const handleDeviceChange = (newDeviceId: string) => {
    setDeviceId(newDeviceId);
  };

  return (
    <div className="analytics-layout">
        <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:px-8">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2">
                <FiDatabase className="text-primary-500 text-xl" />
                <h2 className={classNames(
                  "text-lg font-semibold",
                  {
                    'text-gray-900': mode === 'light',
                    'text-gray-200': mode === 'dark'
                  }
                )}>Sensor Analytics</h2>
              </div>
              <p className={classNames(
                "mt-1 text-sm",
                {
                  'text-gray-500': mode === 'light',
                  'text-gray-400': mode === 'dark'
                }
              )}>
                Real-time monitoring and analysis of sensor data from your devices
              </p>
            </div>
            <div className="flex items-center gap-2 mr-16">
              <DeviceSelectorNew
                onDeviceChange={handleDeviceChange}
                selectedDeviceId={deviceId}
              />
            </div>
          </div>
          <div className="h-0.5 bg-gray-200 dark:bg-gray-700 my-4"></div>
      </div>
      <div className="analytics-content">
        <Outlet />
      </div>
    </div>
  );
};

// Wrapper component that provides the context
const AnalyticsLayout: React.FC = () => {
  return (
    <AnalyticsProvider>
      <AnalyticsLayoutInner />
    </AnalyticsProvider>
  );
};

export default AnalyticsLayout; 
